import z from 'zod';
export const firmIdValue = z.string().trim().min(1).brand('FirmId');
export const createFirmId = (value) => firmIdValue.parse(value);
export const isFirmId = (value) => firmIdValue.safeParse(value).success;
export const firmSubscriptionIdValue = z.string().trim().min(1)
    .brand('FirmSubscriptionId');
export const createFirmSubscriptionId = (value) => firmSubscriptionIdValue.parse(value);
export const isFirmSubscriptionId = (value) => firmSubscriptionIdValue.safeParse(value).success;
export const userIdValue = z.string().trim().min(1).brand('UserId');
export const createUserId = (value) => userIdValue.parse(value);
export const isUserId = (value) => userIdValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map